import type { RootState } from "~/redux/store";
import type { AnyAction } from "~/redux/types";
import type { ThunkAction } from "redux-thunk";
import { fetchTopsellerProducts } from "~/ProductDetails/api/fetchTopsellerProducts";
import type { ProductData } from "~/models/ProductData";

type ThunkResult<R> = ThunkAction<R, RootState, undefined, AnyAction>;

export type TopsellerProductsActions = ReturnType<
  typeof startFetchTopsellerProducts | typeof finishFetchTopsellerProducts
>;

export const START_FETCH_TOPSELLER_PRODUCTS = "PDP: Start Fetch Topseller products";
export const FINISH_FETCH_TOPSELLER_PRODUCTS = "PDP: Finish Fetch Topseller products";

export const startFetchTopsellerProducts = (productCode: string) => {
  return { type: START_FETCH_TOPSELLER_PRODUCTS, payload: { productCode } } as const;
};

export const finishFetchTopsellerProducts = (productCode: string, topsellerProducts: ProductData[], error: boolean) => {
  return { type: FINISH_FETCH_TOPSELLER_PRODUCTS, payload: { productCode, topsellerProducts, error } } as const;
};

export const fetchTopsellerProductsThunk = (productCode: string): ThunkResult<void> => {
  return async (dispatch, getState) => {
    const state = getState();
    if (state.products.topsellerProducts[productCode]?.state === "loaded") {
      return;
    }

    dispatch(startFetchTopsellerProducts(productCode));
    try {
      const topsellerProducts = await fetchTopsellerProducts(productCode);
      dispatch(finishFetchTopsellerProducts(productCode, topsellerProducts, false));
    } catch (error) {
      console.error(error);
      dispatch(finishFetchTopsellerProducts(productCode, [], true));
    }
  };
};
